import React, {Component, Fragment} from 'react';
import {Redirect} from 'react-router-dom';
import {gql} from '@apollo/client';
import {Query} from '@apollo/client/react/components';
import {SiteFooter} from '@homeaway/react-site-footer';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {parse} from 'query-string';
import {triggerEdapPageView} from '../../utils/edap';
import {getRedirect} from '../../utils/redirects';
import {HomeRouteContext} from '../../utils/context';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import HttpError from '../../components/HttpError';
import LoadedPageContainer from './LoadedPageContainer';

const FULL_URL_REDIRECT_REGEXP = /^https?:\/\//;

export const PAGE_QUERY = gql`
    query brandCategories($sitename: String, $preview: Boolean) {
        translationsCollection(where: {site: $sitename}, preview: $preview) {
            items {
                home
                headerButton
                categories
                articles
                exploreArticles
                browseByCategory
                browseBySubcategory
                previous
                next
                expand
                collapse
                openMenu
                closeMenu
                copyLink
            }
        }
        homeCollection(where: {site: $sitename}, preview: $preview) {
            items {
                sys {
                    id
                }
                socialShare
            }
        }
        allCategories: categoryCollection(
            where: {site: $sitename}
            preview: $preview
        ) {
            items {
                name
                slug
                parentId
                path
                partition
                sys {
                    id
                }
            }
        }
    }
`;

class PageContainer extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            triggerEdapPageView();
        }
    }

    render() {
        const {
            client,
            homeRoute,
            location,
            match,
            redirects,
            systemData,
            footerData,
        } = this.props;

        const preview = parse(location.search).preview === 'true';

        const variables = {sitename: systemData.siteName, preview};
        const requestUrl = match.url;

        const redirect = getRedirect(homeRoute, requestUrl, redirects);
        const {
            footerData: {logo},
            ...rest
        } = this.props;

        if (redirect) {
            if (FULL_URL_REDIRECT_REGEXP.test(redirect)) {
                // throw a 414 error (URI Too Long) and let application.tsx handle the situation
                return <HttpError statusCode={414} message={redirect} />;
            }

            return <Redirect to={redirect} />;
        }

        return (
            <Fragment>
                {/* TODO move ScrollToTop to ArticleContainer*/}
                <ScrollToTop {...location} />{' '}
                <HomeRouteContext.Provider value={homeRoute}>
                    <Query client={client} {...{query: PAGE_QUERY, variables}}>
                        {(response) => {
                            return (
                                <LoadedPageContainer
                                    {...{
                                        client,
                                        logo,
                                        response,
                                        ...rest,
                                        preview,
                                    }}
                                />
                            );
                        }}
                    </Query>
                </HomeRouteContext.Provider>
                <SiteFooter data={footerData} site={systemData.siteName} />
            </Fragment>
        );
    }
}

export default determineIfMobile(PageContainer, 991);
